import { render, staticRenderFns } from "./AppConfigView.vue?vue&type=template&id=655463f0&"
import script from "./AppConfigView.vue?vue&type=script&lang=js&"
export * from "./AppConfigView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports